import React, { memo } from 'react';
import { Grid } from 'gridjs-react';
var HistoryResultList = function (_a) {
    var data = _a.data;
    return (React.createElement(Grid, { data: data, columns: [
            {
                name: '更新日時',
                attributes: function () {
                    return {
                        style: 'width: 10px',
                    };
                },
            },
            {
                name: '更新者',
                attributes: function () {
                    return {
                        style: 'width: 10px',
                    };
                },
            },
            {
                name: '更新時状態',
                attributes: function () {
                    return {
                        style: 'width: 10px',
                    };
                },
            },
            {
                name: '更新項目',
                attributes: function () {
                    return {
                        style: 'width:10px',
                    };
                },
            },
            {
                name: '更新前',
                attributes: function () {
                    return {
                        style: 'width: 10px',
                    };
                },
            },
            {
                name: '更新後',
                attributes: function () {
                    return {
                        style: 'width: 10px',
                    };
                },
            },
        ], search: false, sort: true, pagination: {
            enabled: false,
        } }));
};
export default memo(HistoryResultList);
